import { Navigate } from "react-router-dom";

const AuthRoute = ({ children }) => {
  const token = sessionStorage.getItem("access_token");

  if (token) {
    return <Navigate to="/home" replace />;
  }
  
  return children;
};

export default AuthRoute;
